import { Scene, AmbientLight, DirectionalLight, Group, PerspectiveCamera } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { Utils3d } from '../utils/utils3d';

export class Scene3DConfig {
	constructor(){
		this.scene = null;
	}

	init( sceneUnit ) {
		// init scene
		this.#initScene( sceneUnit );

		// init camera
		this.#initCamera( sceneUnit );

		// init controls
		this.#initControls( sceneUnit );		

		// init lights
		this.#initLights( sceneUnit );
	}

	#initScene( sceneUnit ) {
		if( sceneUnit.scene ) 
			sceneUnit.scene.clear();

		sceneUnit.scene = new Scene();
		sceneUnit.scene.name = 'SCENE3D_GROUP';
		Utils3d.makePerformant( sceneUnit.scene );
	}

	#initCamera( sceneUnit ) {
		if( !sceneUnit.camera ) {
			
			//canvas size and aspect ratio
			const canvasSize = sceneUnit.container.getBoundingClientRect();
			const aspect = canvasSize.width / canvasSize.height;

			sceneUnit.camera = new PerspectiveCamera( 75, aspect, 0.1, 10000 );
		}

		sceneUnit.camera.position.set( 100, 100, 100 );
		sceneUnit.camera.updateProjectionMatrix();
	}

	#initControls( sceneUnit ) {
		if( !sceneUnit.controls )
			sceneUnit.controls = new OrbitControls( sceneUnit.camera, document.querySelector( 'canvas' ) ); 
		sceneUnit.controls.enabled = true;
		sceneUnit.controls.enableRotate = true;
		sceneUnit.controls.enablePan = true;
		sceneUnit.controls.enableZoom = true;
		sceneUnit.controls.enableDamping = false;
		sceneUnit.controls.target.set( 0, 0, 0 );
		sceneUnit.controls.update();

		//Looks counter intuitive, but minZoom controls how much you can zoom out, and maxZoom how much you can zoom in
		sceneUnit.controls.minZoom = 0.05;
		sceneUnit.controls.maxZoom = 5;
	}

	#initLights( sceneUnit ) {
		sceneUnit.scene.add( new AmbientLight( 0xffffff, 1 ) );
		const light = new DirectionalLight( 0xffffff, 1 );
		light.position.set( 100, 0.5, 100 );
		sceneUnit.scene.add( light );

		//shadow
		light.castShadow = true;
		light.shadow.mapSize.width = 1024;
		light.shadow.mapSize.height = 1024;
		light.shadow.camera.near = 0.5;
		light.shadow.camera.far = 500;
	}
}

export class CellGroup extends Group { constructor() { super(); this.name = 'CELLS_GROUP'; } }
export class RowGroup extends Group { constructor() { super(); this.name = 'ROW_DIM_GROUP'; } }
export class ColumnGroup extends Group { constructor() { super(); this.name = 'COLUM_DIM_GROUP'; } }
export class DimGroup extends Group { constructor() { super(); this.name = 'GENERAL_DIM_GROUP'; } }